module.exports = __webpack_public_path__ + "static/media/desert.997b33dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/desert.svg
// module id = 575
// module chunks = 1